import { render, staticRenderFns } from "./ProductSupplires.vue?vue&type=template&id=0b225d77&"
import script from "./ProductSupplires.vue?vue&type=script&lang=js&"
export * from "./ProductSupplires.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports